export default "__VITE_ASSET__CMrQ0ixc__"